<!-- 第三步： 选择备选队员组件 -->
<template>
  <div :spinning="loading">
    <p class="title">
      选择该组别预参赛队员
    </p>
    <div class="contentWarp">
      <div class="leftOperation">
        <span class="search">
          <a-input class="search" placeholder="输入队员名称搜索" v-model="searchKeyWords"/>
        </span>
        <span class="add">
          <a-button type="primary" icon="plus" @click="addPlayer" >添加</a-button>
        </span>
        <span class="upload">
          <a-upload
            :showUploadList="false"
            accept=".xls,.xlsx"
            :multiple="false"
            :customRequest="handlerUpload">
            <a-button type="primary" icon="upload">批量添加</a-button>
          </a-upload>
        </span>
        <span class="download">
          <a :href="organisersId === 1 ? heighTechModelFile : normalModelFile"><a-button type="primary" icon="download">下载模板</a-button></a>
        </span>
      </div>
      <div class="leftDiv">
        <div class="playerNum">待选队员&nbsp;&nbsp;{{leftCheckPlayerIndexs.length}}/{{players.length}}</div>
        <div class="playerContainer">
          <template v-for="(player, index) in searchLeftPlayers()">
            <div class="player" v-show="player['del'] !== 'del'" :key="index" :title="player.name" @click="leftPlayerClick(player, index)">
              <img class="head" :src="player.head || defaultHead">
              <img class="checked" v-if="leftCheckPlayerIndexs.indexOf(index) > -1" :src="imgCheck">
              <p>{{ player.name }}</p>
            </div>
          </template>
        </div>
      </div>
      <div class="centerDiv">
        <div class="arrowContent">
          <img class="toRightArrow" :src="leftCheckPlayerIndexs.length > 0 ? arrowRed : arrowWhite" @click="toRight"/>
          <img class="toLeftArrow" :src="rightCheckPlayerIndexs.length > 0 ? arrowRed : arrowWhite" @click="toLeft"/>
        </div>
      </div>
      <div class="rightDiv">
        <div class="playerNum">已选队员&nbsp;&nbsp;{{rightCheckPlayerIndexs.length}}/{{choicedPlayers.length}}</div>
        <div class="playerContainer">
          <div class="player" v-for="(player, index) in choicedPlayers" :key="index" :title="player.name" @click="rightPlayerClick(player, index)">
            <img class="head" :src="player.head || defaultHead">
            <img class="checked" v-if="rightCheckPlayerIndexs.indexOf(index) > -1" :src="imgCheck">
            <p>{{ player.name }}</p>
          </div>
          <div class="btn" @click="submit" v-show="choicedPlayers.length > 0">项目报名</div>
        </div>
      </div>
    </div>
    <AddNormalPlayer ref="addPlayer" @success="addPlayerSuccess"></AddNormalPlayer>
    <BindPlayerHead ref="bindPlayerHead" @success="bindSuccess"></BindPlayerHead>
  </div>
</template>
<script>
import config from '@comm/http/config'
import AddNormalPlayer from '../player/AddNormalPlayer'
import BindPlayerHead from '../player/BindPlayerHead'
import store from '@/store'
import { mapState } from 'vuex'
export default {
  props: {
    playerData: {
      type: Object,
      default: null
    }
  },
  components: {
    AddNormalPlayer,
    BindPlayerHead
  },
  computed: {
    ...mapState({
      joinAgency: state => state.join.joinAgency,
      allChoicedCardIds: state => state.join.allChoicedCardIds
    })
  },
  data () {
    return {
      loading: false,
      uploadUrl: config.baseURL + '/matchJoin/matchJoin/matchPlayer/importSmallballPlayer/' + localStorage.getItem('agencyId'),
      headers: {
        Authorization: 'Bearer ' + store.getters['user/accessToken']
      },
      organisersId: JSON.parse(localStorage.getItem('matchInfo')).agencyId, // 赛事主办方id, 如果是高新区的赛事，在添加队员的时候不选择国籍,需要选择人员类别（在职在编人员、文员、聘用人员）
      defaultHead: require('@comm/assets/join/photo.png'),
      imgCheck: require('@comm/assets/join/imgCheck.png'),
      arrowWhite: require('@comm/assets/join/next.png'),
      arrowRed: require('@comm/assets/join/arrow_red.png'),
      agencyId: this.$route.query.agencyId || null,
      normalModelFile: 'https://static.daoba.com/import_smallball_player.xlsx',
      heighTechModelFile: 'https://static.daoba.com/importSmallball-heigh-model.xlsx',
      players: [],
      choicedPlayers: [],
      leftCheckPlayerIndexs: [],
      rightCheckPlayerIndexs: [],
      matchId: this.$route.query.matchId,
      searchKeyWords: null
    }
  },
  methods: {
    handlerUpload (options) {
      this.importPlayer(options.file)
    },
    // 导入队员
    importPlayer (file) {
      let formData = new FormData()
      formData.append('file', file, 'importSmallballPlayer.xlsx')
      this.loading = true
      this.$api.join.importSmallballPlayer(this.agencyId, this.organisersId, this.matchId, formData).then(res => {
        if (res.status === 0) {
          this.$message.success('导入成功')
          this.addPlayerSuccess()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('上传失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    // 添加队员
    addPlayer () {
      this.$refs.addPlayer.show()
    },
    leftPlayerClick (player, index) {
      // 如果队员没有头像，点击绑定头像
      let head = player.head
      if (head == null) {
        // 绑定头像
        this.$refs.bindPlayerHead.show(player, index)
        return
      }
      let checkIndex = this.leftCheckPlayerIndexs.indexOf(index)
      if (checkIndex > -1) {
        this.leftCheckPlayerIndexs.splice(checkIndex, 1)
      } else {
        this.leftCheckPlayerIndexs.push(index)
      }
    },
    rightPlayerClick (player, index) {
      let checkIndex = this.rightCheckPlayerIndexs.indexOf(index)
      if (checkIndex > -1) {
        this.rightCheckPlayerIndexs.splice(checkIndex, 1)
      } else {
        this.rightCheckPlayerIndexs.push(index)
      }
    },
    toRight () {
      if (this.leftCheckPlayerIndexs.length > 0) {
        this.filterLeftPlayers()
      }
    },
    toLeft () {
      if (this.rightCheckPlayerIndexs.length > 0) {
        this.filterRightPlayers()
      }
    },
    searchLeftPlayers () {
      if (this.searchKeyWords == null || this.searchKeyWords.trim() === '') {
        return this.players
      } else {
        return this.players.filter(player => {
          if (player.name.indexOf(this.searchKeyWords) > -1) {
            return player
          }
        })
      }
    },
    filterLeftPlayers () {
      this.players.forEach((player, index) => {
        if (this.leftCheckPlayerIndexs.indexOf(index) > -1) {
          player['index'] = index
          player['del'] = 'del'
          this.choicedPlayers.push(player)
        }
      })
      this.leftCheckPlayerIndexs = []
    },
    filterRightPlayers () {
      let unChoicePlayers = []
      for (let index = 0; index < this.choicedPlayers.length; index++) {
        let player = this.choicedPlayers[index]
        if (this.rightCheckPlayerIndexs.indexOf(index) > -1) {
          let cardId = player.cardId
          if (this.allChoicedCardIds.indexOf(cardId) > -1) {
            this.$message.error(player.name + '已有报名的参赛项目，请先从参赛项目中移除该队员再进行该操作')
            return
          }
          let playerIndex = player['index']
          this.players[playerIndex]['del'] = null
        } else {
          unChoicePlayers.push(player)
        }
      }
      this.choicedPlayers = unChoicePlayers
      this.rightCheckPlayerIndexs = []
    },
    addPlayerSuccess () {
      this.$emit('addPlayerSuccess')
    },
    bindSuccess (player) {
      let index = player['index']
      let head = player.head
      this.players[index].head = head
    },
    // 提交
    submit () {
      if (this.choicedPlayers.length === 0) {
        this.$message.error('请选择备选队员')
        return
      }
      this.$emit('ok', this.choicedPlayers)
    }
  },
  watch: {
    playerData (newValue, oldValue) {
      this.players = []
      this.choicedPlayers = []
      this.leftCheckPlayerIndexs = []
      this.rightCheckPlayerIndexs = []
      if (newValue == null || newValue.players == null) {
      } else {
        this.players = newValue.players
        newValue.players.forEach((player, index) => {
          player['index'] = index
          if (newValue.choicePlayerIds.indexOf(player.cardId) > -1) {
            player['del'] = 'del'
            let hasChoice = this.choicedPlayers.some(cp => cp.cardId === player.cardId)
            if (!hasChoice) {
              // this.choicedPlayers.push(player)
              // 深拷贝对象，避免多个组件操作同一对象产生业务冲突
              this.choicedPlayers.push(JSON.parse(JSON.stringify(player)))
            }
          } else {
            // let hasChoice = this.choicedPlayers.some(cp => cp.cardId === player.cardId)
            // if (!hasChoice) {
            //   this.players.push(player)
            // }
          }
        })
        store.commit('join/JOIN_ALL_CHOICED_CARD_IDS', newValue.choicePlayerIds)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .title {
    font-size: 19px;
    font-weight: bold;
  }
  .playerNum {
    width:100%;
    clear: both;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 14px;
  }
  .contentWarp {
    .leftOperation {
      display: table;
      width: 630px;
      background-color: #fff;
      .search {
        display: table-cell;
      }
      .add {
        display: table-cell;
        padding-left: 10px;
        width:85px;
      }
      .upload {
        display: table-cell;
        padding-left: 10px;
        width: 115px;
      }
      .download {
        display: table-cell;
        padding-left: 10px;
        width: 115px;
      }
    }
    .playerContainer{
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      padding: 10px;
      overflow: auto;
      max-height: 680px;
      cursor:pointer;
      .player {
        width: 60px;
        height: 110px;
        text-align: center;
        position: relative;
        margin-left: 10px;
        .head {
          height: 80px;
          width: 60px;
        }
        .checked {
          position: absolute;
          top: 0px;
          left: 0px;
          height: 80px;
          width: 60px;
        }
        p {
          cursor:pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .leftDiv {
      float: left;
      width: 630px;
      height: 720px;
      background-color: #fff;
      color: black;
      border: 1px solid #dbdbdb;
    }
    .centerDiv {
      float: left;
      width: 90px;
      height: 720px;
      color: black;
      text-align: center;
      .arrowContent {
        margin-top: 315px;
      }
      .toRightArrow {
        display: block;
        margin: 0 auto;
        transform: rotate(-90deg);
        cursor:pointer;
      }
      .toLeftArrow {
        display: block;
        margin: 0 auto;
        margin-top: 20px;
        transform: rotate(90deg);
        cursor:pointer;
      }
    }
    .rightDiv {
      float: left;
      width: 460px;
      height: 720px;
      background-color: #fff;
      color: black;
      border: 1px solid #dbdbdb;
      position: relative;
      .btn{
        color: #fff;
        width: 100px;
        height: 30px;
        clear: both;
        line-height: 30px;
        margin: 0 auto;
        right: 250px;
        bottom: 29px;
        text-align: center;
        border-radius: 2px;
        background-color: #b80000;
        cursor:pointer;
        position: absolute;
        top: 680px;
        left: 175px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/smallBall/StepThreeAlternativePlayer.vue